module.exports = __webpack_public_path__ + "img/5-5.348b1281.svg";